import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Receiving OIDC authentication", -1)
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted } from 'vue';
import { OidcService } from '@/services/OidcService';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthWithPopupView',
  setup(__props) {

const oidcService = new OidcService();

onMounted(async () => {
  await oidcService.loginAuthorizationCodeFlowWithPkcePopupCallback();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})